<script lang="ts">
import { isContactOpen } from '../../../utils/store';
import Link from '../../atoms/Link/Link.svelte';

interface Props {
    text?: string;
    ctaText?: string;
    hideBlock?: boolean;
}

let { text = '', ctaText = '', hideBlock = false }: Props = $props();
</script>

{#if !hideBlock}
    <div class="sticky-cta">
        <p>{text}</p>
        <Link
            type="button"
            class="button button--inverse"
            onClick={() => {
                $isContactOpen = true;
            }}
        >
            {#snippet text()}
                    {ctaText}
                {/snippet}
        </Link>
    </div>
{/if}

<style lang="scss">
    @use '/src/scss/global-constants/mq-config';
    @use 'sass-mq/mq' as *;

    .sticky-cta {
        background: var(--colour-pickled-pineapple);
        //padding: var(--layout-pagegrid-margin);
        padding: 2rem;
        text-align: center;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 1;

        @include mq($from: tablet) {
            display: none;
        }

        :global(.button) {
            margin-top: 1rem;
        }
    }
</style>
